import { RootState } from '@client/redux/types';

export const getUser = (state: RootState) => state.user;
export const getToken = (state: RootState) => state.user.token;
